angular
    .module('app')
    .controller('UtpTraceSummarySearchController', function(
        $window,
        $uibModalInstance,
        UtpSummarySearchServiceApi,
        toastr,
        user,
        traceSummaryRequest,
        isTesterView,
        searchState,
        moment,
        testerLookups,
        overTheShoulder,
        SettingsService
    ) {
        var vm = this;
        $window.vm = vm;

        vm.userDetails = user;
        vm.data = {};
        vm.datePicker = {};
        vm.state = {
            previouslySelectedTester: null,
            previouslySelectedSim: null,
            previouslySelectedSuite: null,
            previouslySelectedTest: null,
            previouslySelectedTerminalId: null,
            previouslySelectedMerchantId: null,
            selectedTester: null,
            selectedSim: null,
            selectedSuite: null,
            selectedTest: null,
            selectedTerminalId: null,
            selectedMerchantId: null,
            unknownUser: false,
            selectedDate: null,
            selectedDateTo: null,
            enableAdvancedQuery: false,
            advancedQuery: null,
            showError: false,
            errorMsg: '',
            rawMessagesOnly: false,
            DateFormats: {},
            overTheShoulder: overTheShoulder,
            userLabel: user.IsProjectTester ? 'project' : 'tester',
            showSpinner: true
        };
        
        vm.selectDateRange = selectDateRange;
        vm.clearDates = clearDates;
        vm.getUnknownUserTraces = getUnknownUserTraces;
        vm.onSelectedTester = onSelectedTester;
        vm.onSelectedSim = onSelectedSim;
        vm.onSelectedSuite = onSelectedSuite;
        vm.onSelectedDate = onSelectedDate;
        vm.setAdvancedQuery = setAdvancedQuery;
        vm.okSearch = okSearch;
        vm.clearSearch = clearSearch;
        vm.cancel = cancel;
        vm.displayDateRange = displayDateRange;
        vm.clearSelectedDate = clearSelectedDate;
        vm.onSelectedTest = onSelectedTest;
        vm.onSelectedTerminal = onSelectedTerminal;
        vm.onSelectedMerchant = onSelectedMerchant;

        /////////////////// Initial Modal Setup ///////////////////
        function init() {
            vm.state.traceSummaryRequest = traceSummaryRequest;
            resetSearch();
            getSearchModel();
            SettingsService.getSettings().then(function(response) {
                vm.state.DateFormats = {
                    DateTimeFormat: response.data.DateTimeFormat,
                    DateFormat: response.data.DateFormat,
                    TimeFormat: response.data.TimeFormat
                };
                vm.datePicker.options = {
                    alwaysShowCalendars: true,
                    format: vm.state.DateFormats.DateFormat,
                    locale: {
                        cancelLabel: 'Clear'
                    },
                    maxDate: moment(),
                    separator: ' to ',
                    eventHandlers: {
                        'apply.daterangepicker': function(ev, picker) {
                            vm.selectDateRange();
                        },
                        'cancel.daterangepicker': function(ev, picker) {
                            vm.clearDates();
                        }
                    },
                    ranges: {
                        Today: [this.moment(), this.moment()],
                        Yesterday: [
                            this.moment().subtract(1, 'days'),
                            this.moment().subtract(1, 'days')
                        ],
                        'Last 7 Days': [this.moment().subtract(6, 'days'), this.moment()],
                        'Last 30 Days': [
                            this.moment().subtract(29, 'days'),
                            this.moment()
                        ],
                        'This Month': [
                            this.moment().startOf('month'),
                            this.moment().endOf('month')
                        ],
                        'Last Month': [
                            this.moment()
                                .subtract(1, 'month')
                                .startOf('month'),
                            this.moment()
                                .subtract(1, 'month')
                                .endOf('month')
                        ],
                        'Last 3 Months': [
                            this.moment()
                                .subtract(3, 'month')
                                .startOf('month'),
                            this.moment().endOf('month')
                        ]
                    }
                };
                selectDateRange();
            });
        }
        init();

        function setSearchSelections() {
            if (traceSummaryRequest.SimId > 0) {
                vm.state.selectedSim = getItemById(
                    vm.data.Sims,
                    traceSummaryRequest.SimId
                );
                vm.state.previouslyselectedSim = vm.state.selectedSim;
                onSelectedSim(vm.state.selectedSim);
            }
            if (traceSummaryRequest.TestSuiteId > 0) {
                vm.state.selectedSuite = getItemById(
                    vm.data.TestSuites,
                    traceSummaryRequest.TestSuiteId
                );
                vm.state.previouslyselectedSuite = vm.state.selectedSuite;
                onSelectedSuite(vm.state.selectedSuite);
            }
        }

        // Restore our state if there is any to restore
        function setPrevSearchSelections()
        {
            if (searchState) {
                vm.state = searchState;

                if (searchState.selectedDate !== null) {
                    vm.datePicker.date.startDate = moment(searchState.selectedDate);
                } else {
                    vm.datePicker.date.startDate = null;
                }

                if (searchState.selectedDateTo !== null) {
                    vm.datePicker.date.endDate = moment(searchState.selectedDateTo);
                } else {
                    vm.datePicker.date.endDate = null;
                }

                if (vm.state.selectedTester !== null) {
                    getSimulatorsForUser(vm.state.selectedTester.Id);
                }

                if (vm.state.selectedSim !== null) {
                    getTestSuitesForSimulator(vm.state.selectedSim.Id);
                }  

                var suiteId = vm.state.selectedSuite.Id;
                if (suiteId > 0) {
                    getTestsForSuite(suiteId);
                }
            }
        }

        function getSearchModel() {
            if (isTesterView || user.IsTester ||user.IsGroupTester) {
                // If the user undefined or with a request ID of -1 then reset the trace id to the userId unless they are not a tester in which case make it -1 to get all
                if (
                    angular.isUndefined(traceSummaryRequest.UserId) ||
                    traceSummaryRequest.UserId == -1
                ) {
                    if (!user.IsTester && !user.IsGroupTester) {
                        traceSummaryRequest.UserId = -1;
                        UtpSummarySearchServiceApi.getSearchModel().then(function(
                            response
                        ) {
                            response.data.TestCases = vm.data.TestCases;
                            vm.data = response.data;
                            vm.state.selectedTester = vm.data.Testers[0];
                            vm.state.previouslySelectedTester =
                                vm.data.Testers[0];
                            if (!searchState) {
                                setSearchSelections();
                            }
                            else
                            {
                                setPrevSearchSelections();
                            }
                        });
                        return;
                    }
                    traceSummaryRequest.UserId = user.Id;
                }
                UtpSummarySearchServiceApi.getSearchModelById(
                    traceSummaryRequest.UserId
                ).then(function(response) {
                    response.data.TestCases = vm.data.TestCases;
                    vm.data = response.data;
                    vm.state.selectedTester = vm.data.Testers[0];
                    vm.state.previouslySelectedTester = vm.data.Testers[0];
                    if (!searchState) {
                        setSearchSelections();
                    }
                    else
                    {
                        setPrevSearchSelections();
                    }

                    vm.state.showSpinner = false;
                });
            } else {
                UtpSummarySearchServiceApi.getSearchModel().then(function(
                    response
                ) {
                    response.data.TestCases = vm.data.TestCases;
                    vm.data = response.data;
                    vm.data.Testers[0].Name = 'All ' + vm.state.userLabel + 's';
                    if (!searchState) {
                        setSearchSelections();
                    }
                    else
                    {
                        setPrevSearchSelections();
                    }

                    vm.state.showSpinner = false;
                });
            }
        }

        // NOTE: We calc the num recs for searches using the following
        // NOTE: When we return we set the searchDto accordingly
        function resetSearch() {
            if (!isTesterView && !user.IsTester && !user.IsGroupTester) {
                vm.state.selectedTester = { Id: -1, Name: 'All ' + vm.state.userLabel + 's' };
                vm.state.previouslySelectedTester = {
                    Id: -1,
                    Name: 'All ' + vm.state.userLabel + 's'
                };
            }

            vm.state.selectedSim = { Id: -1, Name: 'All simulators' };
            vm.state.selectedSuite = { Id: -1, Name: 'All test suites' };
            vm.state.selectedTest = { Id: -1, Name: 'All test cases' };
            
            vm.state.previouslySelectedSim = { Id: -1, Name: 'All simulators' };
            vm.state.previouslySelectedSuite = {
                Id: -1,
                Name: 'All test suites'
            };
            vm.state.previouslySelectedTest = {
                Id: -1,
                Name: 'All test cases'
            };
            vm.state.previouslySelectedTerminalId = {
                Id: -1,
                Name: 'All Terminal Ids'
            };
            vm.state.previouslySelectedMerchantId = {
                Id: -1,
                Name: 'All Merchant Ids'
            };
            vm.state.selectedTerminalId = vm.state.previouslySelectedTerminalId;
            vm.state.selectedMerchantId = vm.state.previouslySelectedMerchantId;

            clearDates();
            vm.state.enableAdvancedQuery = false;
            vm.state.advancedQuery = '';
            vm.state.showError = false;
            vm.state.errorMsg = '';

            // TODO: Determine if we need the Unknown User parameter
            vm.state.unknownUser = false;

            // NOTE: We should also reset these to the defaults
            vm.state.failedVerdictsOnly = false;
            vm.state.rawMessagesOnly = false;
            vm.state.advancedQueryContains = false;
        }

        function clearSelectedDate() {
            vm.state.selectedDate = null;
            vm.state.selectedDateTo = null;
            setEnableAdvancedQuery();
        }

        function getSearchText() {
            var txt = 'Trace Summary ';
            txt +=
                vm.state.selectedTester.Id == -1
                    ? ' for all ' + vm.state.userLabel + 's'
                    : 'for ' + vm.state.userLabel + ': ' + vm.state.selectedTester.Name;
            txt +=
                vm.state.selectedSim.Id == -1
                    ? ', all simulators'
                    : ', simulator: ' + vm.state.selectedSim.Name;
            txt +=
                vm.state.selectedSuite.Id == -1
                    ? ', all test suites'
                    : ', test suite: ' + vm.state.selectedSuite.Name;
            txt +=
                vm.state.selectedTest.Id == -1
                    ? ', all test cases'
                    : ', test case: ' + vm.state.selectedTest.Name;
            txt +=
                vm.state.selectedDate === null || vm.state.selectedDateTo === null
                    ? ', all dates'
                    : ', date range: ' + vm.displayDateRange();
            txt +=  
                vm.state.selectedTerminalId === null || vm.state.selectedTerminalId === ''
                    ? ', all test Terminal Ids'
                    : ', Terminal Id: ' + vm.state.selectedTerminalId;
            txt += 
                vm.state.selectedMerchantId === null || vm.state.selectedMerchantId === ''
                    ? ', all test Terminal Ids'
                    : ', Terminal Id: ' + vm.state.selectedMerchantId;
            if (vm.state.enableAdvancedQuery) {
                txt +=
                    vm.state.advancedQuery === null
                        ? ', no message criteria'
                        : ', message query: ' + vm.state.advancedQuery;
                if (vm.state.advancedQueryContains) {
                    txt += ' (widened search)';
                }
            }
            // TODO: Fix the failed verdicts only string. Currently it is alwys true.
            // txt += vm.state.failedVerdictsOnly === null || vm.state.failedVerdictsOnly === false ? ', Failed Verdicts Only - False ' : ', Failed Verdicts Only - True ';
            return txt;
        }

        function getUnknownUserTraces() {
            resetSearch();
            vm.traceSummaryRequest.UnknownUser = true;
            var searchDto = {
                traceSummaryRequest: vm.traceSummaryRequest,
                searchText: 'Trace Summary for user with Id = 0'
            };
            $uibModalInstance.close(searchDto);
        }

        /////////////////// Advanced XQuery Functions ///////////////////

        // Check value of selected Tester and call setAdvancedQuery();
        function onSelectedTester() {
            // Reset object on a clear
            if (angular.isUndefined(vm.state.selectedTester) || vm.state.selectedTester == null) {
                vm.state.selectedTester = vm.data.Testers[0];
            }

            if (
                vm.state.previouslySelectedTester.Id ==
                vm.state.selectedTester.Id
            ) {
                return;
            }

            // reset all fields below this dropdown
            vm.state.selectedSim = { Id: -1, Name: 'All simulators' };
            onSelectedSim();

            var userId = vm.state.selectedTester.Id;
            getSimulatorsForUser(userId);
            vm.state.selectedSim = { Id: -1, Name: 'All simulators' };
            setEnableAdvancedQuery();
            vm.state.previouslySelectedTester = vm.state.selectedTester;
        }

        // Check value of selected Simulator and call setAdvancedQuery();
        function onSelectedSim() {
            // Reset object on a clear
            if (angular.isUndefined(vm.state.selectedSim) || vm.state.selectedSim == null) {
                vm.state.selectedSim = vm.data.Sims[0];
            }

            if (vm.state.previouslySelectedSim.Id == vm.state.selectedSim.Id) {
                return;
            }

            // reset all fields below this dropdown
            vm.state.selectedSuite = { Id: -1, Name: 'All test suites' };
            onSelectedSuite(vm.state.selectedSim);

            var simId = vm.state.selectedSim.Id;
            getTestSuitesForSimulator(simId);
            setEnableAdvancedQuery();
            vm.state.previouslySelectedSim = vm.state.selectedSim;
        }

        function onSelectedSuite(selectedSuite) {
            // Reset object on a clear
            if (angular.isUndefined(selectedSuite) || vm.state.selectedSuite == null) {
                vm.state.selectedSuite = vm.data.TestSuites[0];
                // vm.state.selectedTest = { Id: -1, Name: 'All test cases' };
            }

            if (
                vm.state.previouslySelectedSuite.Id == vm.state.selectedSuite.Id
            ) {
                return;
            }

            vm.state.selectedTest = { Id: -1, Name: 'All test cases' };

            var suiteId = vm.state.selectedSuite.Id;
            if (suiteId > 0)
                getTestsForSuite(suiteId);
            vm.state.previouslySelectedSuite = vm.state.selectedSuite;
        }

        function onSelectedTest() {
            if (angular.isUndefined(vm.state.selectedTest) || vm.state.selectedTest == null) {
                vm.state.selectedTest = { Id: -1, Name: 'All test cases' };
            }
        }

        function onSelectedTerminal() {
            if (angular.isUndefined(vm.state.selectedTerminalId) || vm.state.selectedTerminalId == null) {
                vm.state.selectedTerminalId = vm.data.TerminalIdList[0]; // { Id: -1, Name: 'All Terminal Ids' };
            }
        }

        function onSelectedMerchant() {
            if (angular.isUndefined(vm.state.selectedMerchantId) || vm.state.selectedMerchantId == null) {
                vm.state.selectedMerchantId = vm.data.MerchantIdList[0]; // { Id: -1, Name: 'All Terminal Ids' };
            }
        }

        function getSimulatorsForUser(userId) {
            UtpSummarySearchServiceApi.getSimulatorsForUser(userId).then(function(
                response
            ) {
                var sims = response.data;
                if (sims.length > 1) {
                    vm.data.Sims = sims;
                }
                var simId = vm.state.selectedSim.Id;
                if (simId > 0) {
                    vm.state.selectedSim = getItemById(sims, simId);
                    return;
                }
                vm.state.selectedSim = sims[0];
            });
        }

        function getTestSuitesForSimulator(simId) {
            UtpSummarySearchServiceApi.getTestSuitesForUserSim(
                vm.state.selectedTester.Id,
                simId
            ).then(function(response){
                var suites = response.data;
                if (suites.length > 1) {
                    vm.data.TestSuites = suites;
                }
                var suiteId = vm.state.selectedSuite.Id;
                if (suiteId > -1) {
                    vm.state.selectedSuite = getItemById(suites, suiteId);
                    return;
                }
                vm.state.selectedSuite = suites[0];
            });    
        }

        function getTestsForSuite(suiteId) {
            UtpSummarySearchServiceApi.getTestCasesForSuite(suiteId).then(function(
                response
            ) {
                var testCases = response.data;
                vm.data.TestCases = testCases;
                var testId = vm.state.selectedTest.Id;
                if (testId > 0) {
                    vm.state.selectedTest = getItemById(testCases, testId);
                    return;
                }
                vm.state.selectedTest = testCases[0];
            });
        }

        function getItemById(collection, id) {
            // TODO: If we can't find the item we should return the
            return _.find(collection, _.matchesProperty('Id', id));
        }

        // Check value of selected Date and call setAdvancedQuery();
        function onSelectedDate() {
            setEnableAdvancedQuery();
        }

        // Test dependant values and set enableAdvancedQuery
        function setEnableAdvancedQuery() {
            vm.state.enableAdvancedQuery = false;
            if (vm.state.selectedDate !== null && vm.state.selectedDateTo !== null) {
                vm.state.enableAdvancedQuery = true;
            }
        }

        function setAdvancedQuery(queryItem) {
            vm.state.advancedQuery = queryItem;
        }

        /////////////////// End Advanced XQuery Functions ///////////////////

        /////////////////// Modal Dialog button Events ///////////////////

        function okSearch() {
            traceSummaryRequest.UserId = vm.state.selectedTester.Id;
            traceSummaryRequest.SimId = vm.state.selectedSim.Id;
            traceSummaryRequest.TestSuiteId = vm.state.selectedSuite.Id;
            traceSummaryRequest.TestId = vm.state.selectedTest.Id;
            if (vm.datePicker.date !== null)
            {
                traceSummaryRequest.selectedDate =  (vm.datePicker.date.startDate === null) ? null : moment(vm.datePicker.date.startDate).toISOString();
                traceSummaryRequest.selectedDateTo =  (vm.datePicker.date.endDate === null) ? null : moment(vm.datePicker.date.endDate).toISOString();
            }
            else
            {
                traceSummaryRequest.selectedDate = null;
                traceSummaryRequest.selectedDateTo = null;
            }
            
            traceSummaryRequest.TerminalId = vm.state.selectedTerminalId.Id > 0 ? vm.state.selectedTerminalId.Name : '';
            traceSummaryRequest.MerchantId = vm.state.selectedMerchantId.Id > 0 ? vm.state.selectedMerchantId.Name : '';

            // Put the date here for display purposes
            vm.state.selectedDate = traceSummaryRequest.selectedDate;
            vm.state.selectedDateTo = traceSummaryRequest.selectedDateTo;
            vm.state.traceSummaryRequest.selectedDate = traceSummaryRequest.selectedDate;
            vm.state.traceSummaryRequest.selectedDateTo = traceSummaryRequest.selectedDateTo;

            if (vm.state.advancedQuery !== null && vm.state.advancedQuery !== '') {
                // check that advanced query does not contain a single '\'
                var str = vm.state.advancedQuery.replace('\\.', '').replace('\\\\', '').replace('\\=', '');
                if (str.indexOf('\\') !== -1) {
                    toastr.error("Only '.', '=' and '\\' can be escaped using the '\' character.", "Invalid search query");
                    return;
                }
                traceSummaryRequest.advancedQueryContains = vm.state.advancedQueryContains;
                traceSummaryRequest.advancedQuery = vm.state.advancedQuery;
            } else {
                traceSummaryRequest.advancedQuery = '';
                traceSummaryRequest.advancedQueryContains = false;
            }

            vm.state.traceSummaryRequest.failedVerdictsOnly =vm.state.failedVerdictsOnly;
            traceSummaryRequest.failedVerdictsOnly = vm.state.failedVerdictsOnly;
            vm.state.traceSummaryRequest.rawMessagesOnly = vm.state.rawMessagesOnly;
            traceSummaryRequest.rawMessagesOnly = vm.state.rawMessagesOnly;


            if (vm.state.showError === null || !vm.state.showError) {
                var searchDto = {
                    traceSummaryRequest: traceSummaryRequest,
                    searchText: getSearchText(),
                    searchTester: vm.state.selectedTester.Name,
                    searchSim: vm.state.selectedSim.Name,
                    searchSuite: vm.state.selectedSuite.Name,
                    searchTest: vm.state.selectedTest.Name,
                    searchTruncatedTest: vm.state.selectedTest.TruncatedNameNarrow !== null ? vm.state.selectedTest.TruncatedNameNarrow : vm.state.selectedTest.Name,
                    searchDate: vm.state.selectedDate,
                    searchDateTo: vm.state.selectedDateTo,
                    searchAdvancedQuery: vm.state.advancedQuery,
                    advancedQueryContains: vm.state.advancedQueryContains,
                    failedVerdictsOnly: vm.state.failedVerdictsOnly,
                    rawMessagesOnly: vm.state.rawMessagesOnly,
                    TerminalId: vm.data.ShowISO8583Fields ? vm.state.selectedTerminalId.Name : '',
                    MerchantId: vm.data.ShowISO8583Fields ? vm.state.selectedMerchantId.Name : ''
                };
                searchDto.searchState = vm.state;

                vm.data.TesterLookups = testerLookups;
                $uibModalInstance.close(searchDto);
            }
        }

        function clearSearch() {
            resetSearch();
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        // Format date of object passed in DD/MMM/YYYY
        // function formatDate(adate) {
        //     return moment(adate).format(vm.state.DateFormats.DateFormat);
        // }
        /////////////////// END Modal Dialog button Events ///////////////////

        function displayDateRange() {
            if (vm.state.selectedDate === null || vm.state.selectedDateTo === null) {
                return;
            }

            var dateStart = moment(vm.datePicker.date.startDate);
            var dateEnd = moment(vm.datePicker.date.endDate);
            var dateRange =
                '( ' +
                momentFormatDate(dateStart) +
                ' to ' +
                momentFormatDate(dateEnd) +
                ' )';

            return dateRange;
        }

        function momentFormatDate(dt) {
            if (dt === null) {
                return;
            }
            return moment(dt).format(vm.state.DateFormats.DateFormat);
        }

        // TODO: tidy this up as we only need the model here not the picker
        function selectDateRange() {
            vm.state.selectedDate = moment(
                vm.datePicker.date.startDate
            ).toISOString();
            vm.state.selectedDateTo = moment(
                vm.datePicker.date.endDate
            ).toISOString();
            onSelectedDate();
        }

        function clearDates() {
            // This is the default Date range for trace summary
            vm.datePicker = {
                date: {
                    startDate: moment().subtract(3, "days"),
                    endDate: moment()
                }
            };
            selectDateRange();
            setEnableAdvancedQuery();
        }
    });
